import React from 'react';
import Card from '../card/Card';
import { Row, Col, Image, Badge } from 'react-bootstrap';
import { translate } from 'react-i18next';
import { FORMATTER_STYLE, getFormatter } from '../../utils/formatter';
import { getEnvelopeEvaluationStatus } from '../../utils/utility';

class BuildingCard extends React.Component {
  constructor(props) {
    super(props);

    this.defaultStatus = 'unset';

    this.statusMapper = {
      unset: 'status-pending',
      failed: 'status-failed',
      passed: 'status-passed',
    };
  }

  renderName(title) {
    const { t } = this.props;
    return (
      <div>
        <div className="building-title">{title}</div>
      </div>
    );
  }

  renderComponentStatus(name, groupClass, iconClass, status) {
    const { t } = this.props;
    return (
      <div className={'building-field ' + groupClass}>
        <div className="display-icon">
          <i className={iconClass} />
        </div>
        <div className="building-group">
          <div className="display-label">{name}</div>
          <div className="display-value">
            <span className={'building-status ' + this.statusMapper[status]}>
              {t(`${status.toLowerCase()} abbr`).toUpperCase()}
            </span>
          </div>
        </div>
      </div>
    );
  }

  renderBuildingStatus() {
    const { evaluation, status } = this.props.building;
    const {
      evaluation_all_system,
      evaluation_energy_consumption,
    } = evaluation;
    const { t } = this.props;

    return (
      <div className="building-result">
        <div className="row">
          <div className="col-xs-6">
            <div className="evaluate-all-system">
              <div className="display-label">{t('evaluation 1 abbrv')}</div>
              <div className="display-value">{t(evaluation_all_system)}</div>
            </div>
          </div>
          <div className="col-xs-6">
            <div className="evaluate-energy-consumption">
              <div className="display-label">{t('evaluation 2 abbrv')}</div>
              <div className="display-value">{t(evaluation_energy_consumption)}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  getFloatString(value) {
    return getFormatter(FORMATTER_STYLE.floatFractionDigit3)(parseFloat(value));
  }

  render() {
    const { t, i18n } = this.props;
    const {
      name,
      is_owner,
      evaluation,
      image: original_image,
      thumbnail: scaled_image,
    } = this.props.building;

    const thumbnail = original_image || scaled_image;
    const lang = i18n.language.split('-')[0];
    const building_type_name = this.props.building[`building_type_name_${lang}`];
    return (
      <Card
        className={this.props.className ? `building-card ${this.props.className}` : "building-card" }
        header={this.renderName(name)}
        footer={this.renderBuildingStatus()}
        onClick={() => this.props.onClick()}
      >
        <div className="building-type">
          <div className="display-icon">
            <i className="far fa-building" />
          </div>
          <div className="display-group">
            <div className="display-label">
              {t('type')} {!is_owner ? <Badge>{t('S')}</Badge> : null}
            </div>
            <div className="display-value">{building_type_name}</div>
          </div>
        </div>
        <div className="building-card-image">
          <Image src={thumbnail} />
        </div>
        <Row>
          <Col xs={6}>
            {this.renderComponentStatus(
              t('envelop'),
              'key-envelop',
              'fas fa-box',
              evaluation
                ? getEnvelopeEvaluationStatus(evaluation.envelope, this.defaultStatus)
                : this.defaultStatus,
            )}
            {this.renderComponentStatus(
              t('A/C'),
              'key-aircon',
              'fas fa-snowflake',
              evaluation ? evaluation.air_conditioning.status: this.defaultStatus,
            )}
          </Col>
          <Col xs={6}>
            {this.renderComponentStatus(
              t('lighting'),
              'key-lighting',
              'far fa-lightbulb',
              evaluation ? evaluation.lighting_system.status : this.defaultStatus,
            )}
            {this.renderComponentStatus(
              t('hot water'),
              'key-hotwater',
              'fas fa-thermometer-half',
              evaluation ? evaluation.hot_water_system.status : this.defaultStatus,
            )}
          </Col>
        </Row>
      </Card>
    );
  }
}

export default translate('translations')(BuildingCard);



// WEBPACK FOOTER //
// ./src/components/buildingcard/BuildingCard.js